<template>
    <div>
        <div v-if="uploaded">
            <div class="mb-3">Photo added.</div>
            <b-btn variant="primary" pill @click="close">Done</b-btn>
        </div>
        <div v-else-if="error" class="text-danger mb-3">{{ error }}</div>
        <universal-uploader v-else @uploadSuccess="onUpload">
            <b-btn variant="primary" size="lg" pill block>Upload Photo</b-btn>
        </universal-uploader>
    </div>
</template>

<script>
import axios from 'axios';
import UniversalUploader from '@/components/universalUploader/UniversalUploader';

export default {
    props: ['apiUrl'],
    data() {
        return {
            uploaded: false,
            error: null,
        };
    },
    methods: {
        onUpload(url) {
            axios.post(this.apiUrl, { url })
                .then(() => {
                    this.uploaded = true;
                })
                .catch((e) => {
                    this.error = e?.response?.data?.message ?? 'Upload failed';
                });
        },
        close() {
            window.close();
        },
    },
    components: {
        UniversalUploader,
    },
};
</script>
